// @/js/utils.js

/**
 * Debounce function - delays execution until after wait time has passed
 * @param {Function} fn - Function to debounce
 * @param {number} delay - Delay in milliseconds (default: 400)
 * @returns {Function} Debounced function
 */
export const debounce = (fn, delay = 400) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(null, args), delay);
  };
};
